import { Component, OnInit } from '@angular/core';
import { TimetableService } from '../../services/yf-online.data.service';
import { MonthTimetable } from '../../models/event.model';

@Component({
    selector: 'app-year-four-online',
    templateUrl: './year-four-online.component.html',
    styleUrls: ['./year-four-online.component.css'],
    standalone: false
})
export class YearFourOnlineComponent implements OnInit {

  months: string[] = [];
    selectedMonth: string = 'Online';
    timetable: MonthTimetable = {};
  
    constructor(private timetableService: TimetableService) {}
  
    ngOnInit() {
      this.months = this.timetableService.getMonths();
      this.timetable = this.timetableService.getTimetable();
    }
  
    selectMonth(month: string) {
      this.selectedMonth = month;
    }

}
